import { LOGIN } from "../actions/index";

export default function(state = {}, action) {
  switch (action.type) {
    case LOGIN:
      if (action.payload) {
        window.sessionStorage.accessToken = action.payload.token;
      } else {
        return state;
      }
      return { ...state, token: action.payload.token };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/Login.js